module.exports = __webpack_public_path__ + "static/media/spicyLevel20.bb0c2eb5.svg";